import React from "react";

export default function About() {
  return (
    <div style={{height:"63vh"}}>
      <h1
        style={{
          textAlign: "center",
          marginTop: "3rem",
          fontSize: "2rem",
          fontWeight: "600",
          margin: "3rem 0",
        }}
      >
        About Section
      </h1>
    </div>
  );
}
